import { Message } from "primereact/message";
import { classNames } from "primereact/utils";
import styles from "./aviso-condicoes.module.scss";
import type {
  AvisoLimitesTiposViewModel,
  MensagensRevisaoCondicoesViewModel,
} from "./types-aviso-condicoes";

function AvisoWarn({
  children,
  testId,
}: {
  readonly children: React.ReactNode;
  readonly testId: string;
}) {
  return (
    <Message
      severity="warn"
      role="status"
      className={classNames("p-message-block", styles.aviso)}
      data-testid={testId}
      text={children}
    />
  );
}

/**
 * Aviso da etapa Tipos de Obra (HU 2549, MS001/MS002; Figma `11209:395`): limites que vencem antes
 * do início ou durante a obra. Cada limite sai quando o tipo que o renova entra; sem pendência, some.
 * Não bloqueia a navegação.
 */
export function AvisoLimitesTiposView({ texto }: AvisoLimitesTiposViewModel) {
  if (!texto) return null;

  return <AvisoWarn testId="aviso-limites-tipos">{texto}</AvisoWarn>;
}

/**
 * Mensagens da Revisão (HU 2549, MS003–MS005; Figma `11209:397`): uma por ponto pendente, sem botão
 * fechar, cada uma some quando o ponto é resolvido. Não impede chegar ao Criar Obra.
 */
export function MensagensRevisaoCondicoesView({ mensagens }: MensagensRevisaoCondicoesViewModel) {
  if (mensagens.length === 0) return null;

  return (
    <div className={styles.lista} data-testid="mensagens-revisao-condicoes">
      {mensagens.map((mensagem) => (
        <AvisoWarn key={mensagem.chave} testId={mensagem.testId}>
          <strong>{mensagem.titulo}:</strong> {mensagem.texto}
        </AvisoWarn>
      ))}
    </div>
  );
}
